var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProgBarStart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96.4 358.4",
    style: {
      enableBackground: "new 0 0 96.4 358.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C7C7C7;}\r\n\t.st1{opacity:0.5;fill:#C7C7C7;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.4,336.7v-90.8c0-7.6-6.2-13.8-13.8-13.8h0c-7.6,0-13.8,6.2-13.8,13.8v90.8c0,7.6,6.2,13.8,13.8,13.8h0 C58.2,350.6,64.4,344.3,64.4,336.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.4,206l25.4-25.4c5.4-5.4,5.4-14.2,0-19.6l0,0c-5.4-5.4-14.2-5.4-19.6,0l-25.4,25.4 c-5.4,5.4-5.4,14.2,0,19.6l0,0C46.2,211.4,55,211.4,60.4,206z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.5,206l-25.4-25.4c-5.4-5.4-5.4-14.2,0-19.6l0,0c5.4-5.4,14.2-5.4,19.6,0l25.4,25.4c5.4,5.4,5.4,14.2,0,19.6 l0,0C54.7,211.4,45.9,211.4,40.5,206z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.4,157.8l25.4-25.4c5.4-5.4,5.4-14.2,0-19.6l0,0c-5.4-5.4-14.2-5.4-19.6,0l-25.4,25.4 c-5.4,5.4-5.4,14.2,0,19.6l0,0C46.2,163.2,55,163.2,60.4,157.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.5,157.8l-25.4-25.4c-5.4-5.4-5.4-14.2,0-19.6l0,0c5.4-5.4,14.2-5.4,19.6,0l25.4,25.4 c5.4,5.4,5.4,14.2,0,19.6l0,0C54.7,163.2,45.9,163.2,40.5,157.8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.4,107.6l25.4-25.4c5.4-5.4,5.4-14.2,0-19.6l0,0c-5.4-5.4-14.2-5.4-19.6,0L40.8,88c-5.4,5.4-5.4,14.2,0,19.6 l0,0C46.2,112.9,55,112.9,60.4,107.6z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.5,107.6L15.1,82.2c-5.4-5.4-5.4-14.2,0-19.6l0,0c5.4-5.4,14.2-5.4,19.6,0L60.1,88c5.4,5.4,5.4,14.2,0,19.6 l0,0C54.7,112.9,45.9,112.9,40.5,107.6z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.4,61.4L85.8,36c5.4-5.4,5.4-14.2,0-19.6l0,0c-5.4-5.4-14.2-5.4-19.6,0L40.8,41.8c-5.4,5.4-5.4,14.2,0,19.6 l0,0C46.2,66.8,55,66.8,60.4,61.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.5,61.4L15.1,36c-5.4-5.4-5.4-14.2,0-19.6l0,0c5.4-5.4,14.2-5.4,19.6,0l25.4,25.4c5.4,5.4,5.4,14.2,0,19.6 l0,0C54.7,66.8,45.9,66.8,40.5,61.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.4,253.2l25.4-25.4c5.4-5.4,5.4-14.2,0-19.6l0,0c-5.4-5.4-14.2-5.4-19.6,0l-25.4,25.4 c-5.4,5.4-5.4,14.2,0,19.6l0,0C46.2,258.6,55,258.6,60.4,253.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.5,253.2l-25.4-25.4c-5.4-5.4-5.4-14.2,0-19.6l0,0c5.4-5.4,14.2-5.4,19.6,0l25.4,25.4 c5.4,5.4,5.4,14.2,0,19.6l0,0C54.7,258.6,45.9,258.6,40.5,253.2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.2,233.9l-9.7-9.7l-9.7,9.7c-5.4,5.4-5.4,14.2,0,19.6h0c2.7,2.7,6.2,4,9.7,4c3.5,0,7-1.4,9.7-4h0 C65.6,248.1,65.6,239.3,60.2,233.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgBarStart);
export default __webpack_public_path__ + "static/media/ProgBar_start.b46969eb0241af0abb18e8892f1f4d99.svg";
export { ForwardRef as ReactComponent };